import { Directive } from '@angular/core';
import { AbstractControlDirective, NgControl } from '@angular/forms';

@Directive()
export abstract class CaFormFieldControl<T> {
  value: T | null;
  readonly ngControl: NgControl | AbstractControlDirective | null;
}
